var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10.8555 18H14.8555V16H10.8555V18ZM3.85547 6V8H21.8555V6H3.85547ZM6.85547 13H18.8555V11H6.85547V13Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
